/* ================================================================
   uf-tienda.js — comportamiento de las secciones UF del tema:
     uf-home (configurador + sueltas) · uf-pack-pdp · uf-playera-pdp
   Versión Shopify del mockup/uf-tienda.js: precios, variantes, stock y
   fotos llegan de Liquid en un <script type="application/json" data-uf>,
   nunca escritos acá. Cada módulo arranca solo si su HTML está en la página.
   ================================================================ */
(function(){
'use strict';

const $  = (s, r=document) => r.querySelector(s);
const $$ = (s, r=document) => [...r.querySelectorAll(s)];
const PARAMS = new URLSearchParams(location.search);
const MOVIMIENTO = !matchMedia('(prefers-reduced-motion: reduce)').matches;

const datosEl = $('script[data-uf]');
if (!datosEl) return;
const D = JSON.parse(datosEl.textContent);
const CFG = D.config;                         // envío, % 2º pack, combos (snippets/uf-datos.liquid)

const pesos = cents => '$' + Math.round(cents / 100).toLocaleString('es-MX');
const img = (base, ancho) => base ? `${base}${base.includes('?') ? '&' : '?'}width=${ancho}` : '';
/* Buen Fin: activo entre las fechas de config.buen_fin (o con ?buenfin=1 para probar).
   El descuento real lo aplica el descuento automático de Shopify en el carrito; acá solo se muestra. */
const BF = (() => {
  const b = (D.config || {}).buen_fin; if (!b) return null;
  const t = Date.now(), on = PARAMS.get('buenfin') === '1' || (t >= Date.parse(b.inicio) && t <= Date.parse(b.fin));
  return on ? b : null;
})();
function lineaBF(raiz, totalCents){
  const el = $('[data-uf-bf]', raiz); if (!el) return;
  if (!BF || totalCents < BF.minimo){ el.hidden = true; return; }
  el.hidden = false;
  el.innerHTML = `<b>Buen Fin: −${BF.pct}% extra</b> · te queda en ${pesos(totalCents * (100 - BF.pct) / 100)} en el carrito`;
}
const slugCombo = nombre => /negro/i.test(nombre) ? 'negro' : 'variedad';

/* Color de cada suelta a partir de su título ("… Manga Corta Azul Marino") */
const COLORES = [
  { slug:'azul',   rx:/azul/i,   nom:'Azul Marino',   hex:'#1E2C57' },
  { slug:'gris',   rx:/gris/i,   nom:'Gris Jaspeado', hex:'#B4B4B8' },
  { slug:'arena',  rx:/arena/i,  nom:'Arena',         hex:'#CDBFA6' },
  { slug:'blanco', rx:/blanc/i,  nom:'Blanco',        hex:'#F1F1EE' },
  { slug:'negro',  rx:/negr/i,   nom:'Negro',         hex:'#17171B' },
];
const colorDe = titulo => COLORES.find(c => c.rx.test(titulo)) || { slug:'otro', nom:titulo, hex:'#ccc' };

/* Sueltas indexadas por color: fotos [con modelo, plana] y variantes */
const SUELTAS = {};
(D.sueltas || []).forEach(p => { const c = colorDe(p.title); SUELTAS[c.slug] = Object.assign({ color:c }, p); });
/* Orden de los colores: el del metacampo custom.colores en Shopify */
const ORDEN = (D.sueltas || []).map(p => colorDe(p.title));
const HEX = slug => (SUELTAS[slug] ? SUELTAS[slug].color.hex : (COLORES.find(c => c.slug === slug) || {}).hex);
const NOM = slug => (COLORES.find(c => c.slug === slug) || {}).nom || slug;

function boton(txt, attrs={}, cls='opcion'){
  const b = document.createElement('button');
  b.type = 'button'; b.className = cls; b.innerHTML = txt;
  for (const [k,v] of Object.entries(attrs)) b.setAttribute(k, v);
  return b;
}
const marcar = (raiz, sel, attr, val) => $$(sel, raiz).forEach(b =>
  b.setAttribute('aria-pressed', String(b.dataset[attr] === String(val))));

/* La talla elegida viaja entre páginas (URL o localStorage) */
const TALLAS = ['Chico', 'Mediano', 'Grande', 'Extra Grande'];
function tallaGuardada(){
  const p = PARAMS.get('talla');
  if (TALLAS.includes(p)) return p;
  try { const t = localStorage.getItem('uf-talla'); if (TALLAS.includes(t)) return t; } catch(e){}
  return 'Grande';
}
function guardarTalla(t){ try { localStorage.setItem('uf-talla', t); } catch(e){} }

function envioTxt(raiz, totalCents){
  const gratis = totalCents >= CFG.envio_gratis_desde * 100;
  const el = $('[data-uf-envio]', raiz);
  el.style.color = gratis ? 'var(--ok)' : 'var(--ink-2)';
  $('[data-uf-envio-txt]', raiz).textContent = gratis
    ? `Envío gratis (pedidos desde $${CFG.envio_gratis_desde})`
    : `Envío $${CFG.envio_costo} · gratis desde $${CFG.envio_gratis_desde} (te faltan ${pesos(CFG.envio_gratis_desde * 100 - totalCents)})`;
}

/* ============================================================
   CARRITO — /cart/add.js y el carrito lateral de Impulse
   ============================================================ */
async function agregar(raiz, id, cantidad, alCheckout, btn){
  const aviso = $('[data-uf-aviso]', raiz);
  aviso.textContent = '';
  btn.disabled = true;
  try {
    const r = await fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items:[{ id, quantity:cantidad }] }),
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'No se pudo agregar');
    if (alCheckout) { location.href = '/checkout'; return; }
    /* Impulse 9: 'ajaxProduct:added' reconstruye y abre el carrito lateral.
       Si la tienda usa carrito de página, se va al carrito. */
    const tipo = window.theme && theme.settings && theme.settings.cartType;
    if (tipo === 'drawer') document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail:{ product:data.items ? data.items[0] : data }, bubbles:true }));
    else location.href = '/cart';
  } catch (e) {
    aviso.textContent = e.message;
  } finally {
    btn.disabled = false;
  }
}

/* ============================================================
   GALERÍA
   ============================================================ */
function crearGaleria(raiz){
  const G = { firma:'', turno:0, i:0 };
  const main = $('[data-uf-foto]', raiz), th = $('[data-uf-thumbs]', raiz);
  G.pintar = fotos => {
    fotos = fotos.filter(x => x.f);
    if (!fotos.length) return;
    G.i = Math.min(G.i, fotos.length - 1);
    const firma = fotos.map(x => x.f).join('|');
    if (firma !== G.firma){
      G.firma = firma;
      th.innerHTML = '';
      fotos.forEach((x, i) => th.appendChild(boton(
        `<img src="${img(x.f, 160)}" width="160" height="160" loading="lazy" decoding="async" alt="">`,
        { 'data-foto':i, 'aria-pressed':'false', 'aria-label':`Foto ${i+1}: ${x.alt}` }, 'thumb')));
    }
    $$('.thumb', th).forEach(b => b.setAttribute('aria-pressed', String(+b.dataset.foto === G.i)));
    const x = fotos[G.i];
    if (main.dataset.f === x.f) return;
    main.dataset.f = x.f;
    const mio = ++G.turno;
    main.classList.add('is-cambiando');
    const pre = new Image();
    pre.sizes = main.sizes;
    pre.srcset = [540, 720, 1080, 1440].map(w => `${img(x.f, w)} ${w}w`).join(', ');
    pre.src = img(x.f, 1080);
    const poner = () => {
      if (mio !== G.turno) return;
      main.srcset = pre.srcset; main.src = pre.src; main.alt = x.alt;
      main.classList.remove('is-cambiando');
    };
    (pre.decode ? pre.decode() : Promise.resolve()).then(poner, poner);
  };
  G.precargar = lista => {
    const ir = () => lista.filter(Boolean).forEach(f => { const i = new Image(); i.src = img(f, 1080); });
    ('requestIdleCallback' in window) ? requestIdleCallback(ir, { timeout:3000 }) : setTimeout(ir, 1500);
  };
  return G;
}

/* ============================================================
   MÓDULO PACK — configurador (home y página del pack)
   Los tres tamaños son productos distintos (pack-x3/x5/x8): la página los
   muestra juntos y cambia de uno a otro sin recargar.
   ============================================================ */
function iniciarPack(raiz){
  const PACKS = D.packs;                                  // { "3": {url, variants:[…]}, … }
  const tamanos = Object.keys(PACKS).map(Number).sort((a,b) => a-b);
  const esPdp = raiz.dataset.ufModo === 'pdp';
  const inicial = raiz.dataset.ufPack ? +raiz.dataset.ufPack : 8;
  const P = {
    pack:  PACKS[PARAMS.get('pack')] ? +PARAMS.get('pack') : inicial,
    combo: ['variedad','negro'].includes(PARAMS.get('combo')) ? PARAMS.get('combo') : (raiz.dataset.ufCombo || 'variedad'),
    talla: tallaGuardada(),
  };
  const G = crearGaleria(raiz);

  const variante = () => PACKS[P.pack].variants.find(v => slugCombo(v.combo) === P.combo && v.talla === P.talla);

  const c = $('[data-uf-op="combo"]', raiz); c.innerHTML = '';
  [['variedad','Variedad'],['negro','Todo Negro']].forEach(([slug, nom]) =>
    c.appendChild(boton(nom, { 'data-combo':slug, 'aria-pressed':'false' })));
  const p = $('[data-uf-op="pack"]', raiz); p.innerHTML = '';
  tamanos.forEach(n => {
    const v = PACKS[n].variants[0];
    const chip = n === 5 ? '<span class="uf-chip opcion__chip">Best seller</span>' : '';
    p.appendChild(boton(`${chip}×${n}<span class="sub">${pesos(v.price / n)} c/u</span>`, { 'data-pack':n, 'aria-pressed':'false' }));
  });
  const t = $('[data-uf-op="talla"]', raiz); t.innerHTML = '';
  TALLAS.forEach(x => t.appendChild(boton(x, { 'data-talla':x, 'aria-pressed':'false' })));

  function fotos(){
    const v = variante();
    const nom = P.combo === 'negro' ? 'Todo Negro' : 'Variedad';
    const lista = [{ f: v && v.img, alt:`Pack x${P.pack} ${nom} de playeras UrbanFit` }];
    const piezas = CFG.combos[P.combo][P.pack] || [];
    /* Un solo color (Todo Negro): todas sus fotos. Variedad: la foto plana de cada color. */
    piezas.forEach(([slug]) => {
      const s = SUELTAS[slug]; if (!s) return;
      (piezas.length === 1 ? s.imgs : [s.plana]).forEach(f => {
        if (f) lista.push({ f, alt:`Playera UrbanFit ${NOM(slug)} incluida en el pack` });
      });
    });
    return lista;
  }

  function render(){
    const v = variante();
    marcar(raiz, '[data-uf-op="talla"] .opcion', 'talla', P.talla);
    marcar(raiz, '[data-uf-op="combo"] .opcion', 'combo', P.combo);
    marcar(raiz, '[data-uf-op="pack"] .opcion',  'pack',  P.pack);
    $('[data-uf-v="talla"]', raiz).textContent = P.talla;
    $('[data-uf-v="combo"]', raiz).textContent = P.combo === 'negro' ? 'Todo Negro' : 'Variedad';
    $('[data-uf-v="pack"]', raiz).textContent  = '×' + P.pack + (P.pack === 5 ? ' — Best seller' : '');

    G.pintar(fotos());
    const piezas = CFG.combos[P.combo][P.pack] || [];
    $('[data-uf-pie-nom]', raiz).textContent = `Pack ×${P.pack} ${P.combo === 'negro' ? 'Todo Negro' : 'Variedad'}`;
    $('[data-uf-piezas]', raiz).innerHTML = piezas.map(([slug, n]) => `
      <span class="pieza">
        <span class="pieza__sw" style="background:${HEX(slug)}">${n > 1 ? `<span class="pieza__x">×${n}</span>` : ''}</span>
        <span class="pieza__nm">${NOM(slug)}</span>
      </span>`).join('');

    if (!v) return;
    /* Ahorro contra las mismas playeras sueltas al precio real de la suelta (no el precio tachado) */
    const antes = CFG.suelta_precio * P.pack > v.price ? CFG.suelta_precio * P.pack : 0;
    $('[data-uf-precio]', raiz).textContent = pesos(v.price);
    /* Sin precio tachado: el total de sueltas no fue un precio anterior (PROFECO). El ahorro va en texto. */
    $('[data-uf-antes]', raiz).textContent = '';
    $('[data-uf-unidad]', raiz).textContent = `${pesos(v.price / P.pack)} por playera`;
    $('[data-uf-ahorro]', raiz).textContent = antes ? `Ahorras ${pesos(antes - v.price)} contra comprarlas sueltas` : '';
    envioTxt(raiz, v.price);
    lineaBF(raiz, v.price);

    const segundo = Math.round(v.price * (100 - CFG.descuento_2do) / 100);
    $('[data-uf-upsell]', raiz).innerHTML =
      `Suma otro pack —del tamaño y combo que quieras— y el de menor precio te sale ${CFG.descuento_2do}% menos. `
      + `<b>Se aplica solo en el carrito.</b> Ej.: otro ×${P.pack} por ${pesos(segundo)}`
      + (v.price < CFG.envio_gratis_desde * 100 ? ', y tu envío pasa a ser gratis.' : '.');

    const comprar = $('[data-uf-comprar]', raiz), carrito = $('[data-uf-carrito]', raiz);
    comprar.textContent = v.available ? `Comprar ahora — ${pesos(v.price)}` : 'Agotado';
    comprar.disabled = carrito.disabled = !v.available;

    if (esPdp){
      const q = new URLSearchParams({ variant:v.id, combo:P.combo, talla:P.talla });
      history.replaceState(null, '', `${PACKS[P.pack].url}?${q}`);
      const h1 = $('[data-uf-h1]', raiz); if (h1) h1.textContent = `Pack de ${P.pack} Playeras Cuello Redondo`;
    }
  }

  raiz.addEventListener('click', e => {
    const b = e.target.closest('[data-talla],[data-combo],[data-pack],[data-foto],[data-uf-comprar],[data-uf-carrito]');
    if (!b) return;
    if (b.dataset.talla)      { P.talla = b.dataset.talla; guardarTalla(P.talla); }
    else if (b.dataset.combo) { P.combo = b.dataset.combo; G.i = 0; }
    else if (b.dataset.pack)  { P.pack  = +b.dataset.pack; G.i = 0; }
    else if (b.dataset.foto)  G.i = +b.dataset.foto;
    else { const v = variante(); if (v) agregar(raiz, v.id, 1, b.hasAttribute('data-uf-comprar'), b); return; }
    render();
  });

  render();
  G.precargar(tamanos.flatMap(n => PACKS[n].variants.map(v => v.img)).concat(Object.values(SUELTAS).map(s => s.plana)));
}

/* ============================================================
   MÓDULO SUELTA — página de la playera suelta
   Cada color es un producto; el metacampo custom.colores los enlaza y la
   página cambia de color sin recargar.
   ============================================================ */
function iniciarSuelta(raiz){
  const actual = colorDe(raiz.dataset.ufTitulo).slug;
  const S = {
    color: SUELTAS[PARAMS.get('color')] ? PARAMS.get('color') : actual,
    talla: tallaGuardada(),
    cant: 1,
  };
  const G = crearGaleria(raiz);
  const variante = () => (SUELTAS[S.color].variants || []).find(v => v.talla === S.talla);

  const oc = $('[data-uf-op="color"]', raiz); oc.innerHTML = '';
  ORDEN.forEach(c => oc.appendChild(boton('', { 'data-color':c.slug, 'aria-pressed':'false', 'aria-label':c.nom,
                                                title:c.nom, style:`background:${c.hex}` }, 'swatch')));
  const t = $('[data-uf-op="talla"]', raiz); t.innerHTML = '';
  TALLAS.forEach(x => t.appendChild(boton(x, { 'data-talla':x, 'aria-pressed':'false' })));

  const packPara = n => n <= 3 ? 3 : n <= 5 ? 5 : 8;

  function alPack(){
    const n = packPara(S.cant);
    const pack = D.packs[n];
    if (!pack) return;
    const combo = S.color === 'negro' ? 'negro' : 'variedad';
    const v = pack.variants.find(x => slugCombo(x.combo) === combo && x.talla === S.talla) || pack.variants[0];
    const piezas = CFG.combos[combo][n] || [];
    const incluye = piezas.some(([s]) => s === S.color);
    const suelta = SUELTAS[S.color].variants[0].price;
    const sueltas = S.cant * suelta;
    let titulo, texto;
    if (S.cant < 3){
      titulo = `Llévate 3 por ${pesos(v.price)}`;
      texto  = `En el pack ×3 cada playera sale en ${pesos(v.price / 3)} en lugar de ${pesos(suelta)}. `
             + `Ahorras ${pesos(3 * suelta - v.price)} contra 3 sueltas.`;
    } else if (sueltas > v.price){
      const extra = n - S.cant;
      titulo = `${S.cant} sueltas: ${pesos(sueltas)}. El pack ×${n}: ${pesos(v.price)}`;
      texto  = extra > 0
        ? `Pagas ${pesos(sueltas - v.price)} menos y te llevas ${extra} ${extra === 1 ? 'playera' : 'playeras'} más.`
        : `Ahorras ${pesos(sueltas - v.price)} con las mismas ${n} playeras.`;
    } else {
      titulo = `El pack ×${n} por ${pesos(v.price)}`;
      texto  = `${pesos(v.price / n)} por playera.`;
    }
    if (v.price >= CFG.envio_gratis_desde * 100) texto += ' Y el pack viaja con envío gratis.';
    $('[data-uf-al-t]', raiz).textContent = titulo;
    $('[data-uf-al-s]', raiz).textContent = texto;
    $('[data-uf-al-c]', raiz).textContent = (combo === 'negro' ? 'Todo Negro'
      : 'Variedad: ' + piezas.map(([s, k]) => (k > 1 ? k + ' ' : '') + NOM(s)).join(', '))
      + (incluye ? '' : ` · no incluye ${NOM(S.color)}`);
    $('[data-uf-al-img]', raiz).src = img(v.img, 240);
    $('[data-uf-al-cta]', raiz).textContent = `Ver pack ×${n}`;
    $('[data-uf-al]', raiz).href = `${pack.url}?${new URLSearchParams({ variant:v.id, combo, talla:S.talla })}`;
  }

  function render(){
    const s = SUELTAS[S.color], v = variante();
    marcar(raiz, '[data-uf-op="color"] .swatch', 'color', S.color);
    marcar(raiz, '[data-uf-op="talla"] .opcion', 'talla', S.talla);
    $$('[data-uf-op="talla"] .opcion', raiz).forEach(b => {
      const x = s.variants.find(y => y.talla === b.dataset.talla);
      b.classList.toggle('is-agotado', !x || !x.available);
    });
    $('[data-uf-v="color"]', raiz).textContent = s.color.nom;
    $('[data-uf-v="talla"]', raiz).textContent = S.talla + (v && !v.available ? ' · agotada' : '');
    $('[data-uf-cant]', raiz).textContent = S.cant;
    $('[data-uf-menos]', raiz).disabled = S.cant <= 1;
    $('[data-uf-mas]', raiz).disabled = S.cant >= 10;

    G.pintar(s.imgs.map((f, i) => ({ f, alt:(s.alts && s.alts[i]) || `Playera UrbanFit ${s.color.nom}` })));
    $('[data-uf-pie-nom]', raiz).textContent = `Playera ${s.color.nom}`;

    const precio = v ? v.price : s.variants[0].price;
    const total = S.cant * precio;
    $('[data-uf-precio]', raiz).textContent = pesos(total);
    $('[data-uf-unidad]', raiz).textContent = S.cant > 1 ? `${S.cant} × ${pesos(precio)}` : '';
    envioTxt(raiz, total);
    lineaBF(raiz, total);
    const disponible = v && v.available;
    const comprar = $('[data-uf-comprar]', raiz), carrito = $('[data-uf-carrito]', raiz);
    comprar.textContent = disponible ? `Comprar ahora — ${pesos(total)}` : 'Agotado en esta talla';
    comprar.disabled = carrito.disabled = !disponible;
    alPack();

    history.replaceState(null, '', `${s.url}?${new URLSearchParams({ talla:S.talla })}`);
    const h1 = $('[data-uf-h1]'); if (h1) h1.textContent = `Playera ${s.title.replace(/^Playera UrbanFit Hombre Manga Corta /, '')} Cuello Redondo`;
  }

  raiz.addEventListener('click', e => {
    const b = e.target.closest('[data-color],[data-talla],[data-foto],[data-uf-menos],[data-uf-mas],[data-uf-comprar],[data-uf-carrito]');
    if (!b) return;
    if (b.dataset.color)       { S.color = b.dataset.color; G.i = 0; }
    else if (b.dataset.talla)  { S.talla = b.dataset.talla; guardarTalla(S.talla); }
    else if (b.dataset.foto)   G.i = +b.dataset.foto;
    else if (b.hasAttribute('data-uf-menos')) S.cant = Math.max(1, S.cant - 1);
    else if (b.hasAttribute('data-uf-mas'))   S.cant = Math.min(10, S.cant + 1);
    else { const v = variante(); if (v) agregar(raiz, v.id, S.cant, b.hasAttribute('data-uf-comprar'), b); return; }
    render();
  });

  render();
  G.precargar(Object.values(SUELTAS).flatMap(s => s.imgs));
}

/* ============================================================
   MÓDULO SUELTAS — grilla de colores de la home
   ============================================================ */
function pintarSueltas(grid){
  grid.innerHTML = ORDEN.map(c => {
    const s = SUELTAS[c.slug], plana = s.imgs[0];          // la foto principal del admin
    const rapido = { v: s.variants.map(v => ({ id:v.id, t:v.talla, a:!!v.available })) };
    const disponible = rapido.v.some(v => v.a);
    return `
    <div class="color-card">
    <a class="color-card__link" href="${s.url}">
      <span class="color-card__media">
        <span class="color-card__foto">
          <img src="${img(plana, 480)}" srcset="${img(plana, 320)} 320w, ${img(plana, 480)} 480w, ${img(plana, 720)} 720w"
               sizes="(max-width:560px) 72vw, (max-width:1068px) 30vw, 240px"
               width="480" height="600" loading="lazy" decoding="async" alt="Playera UrbanFit cuello redondo color ${c.nom}">
        </span>
        ${c.slug === 'negro' ? '<span class="uf-chip color-card__chip">Más vendida</span>' : ''}
      </span>
      <span class="color-card__txt">
        <span class="color-card__sw" style="background:${c.hex}"></span>
        <span class="color-card__nom">${c.nom}</span>
        <span class="color-card__sub">${pesos(s.variants[0].price)}</span>
      </span>
    </a>
    <div class="uf-rapido uf-rapido--pill" data-uf-rapido="${JSON.stringify(rapido).replace(/&/g,'&amp;').replace(/"/g,'&quot;')}">
      <button type="button" class="uf-rapido__btn" data-uf-rapido-btn aria-expanded="false" aria-label="Agregar playera ${c.nom} al carrito"${disponible ? '' : ' disabled'}>
        <svg class="ico uf-rapido__mas" aria-hidden="true"><use href="#uf-plus"/></svg>
        <svg class="ico uf-rapido__ok" aria-hidden="true"><use href="#uf-check"/></svg>
        <span class="uf-rapido__txt">${disponible ? 'Agregar' : 'Agotado'}</span>
      </button>
    </div>
    </div>`;
  }).join('');
}

/* ============================================================
   REVEAL — se desactiva entero con prefers-reduced-motion
   ============================================================ */
function reveal(){
  const nodos = $$('.uf .reveal');
  if (!MOVIMIENTO || !('IntersectionObserver' in window)) return nodos.forEach(n => n.classList.add('is-in'));
  const io = new IntersectionObserver((entradas, obs) => {
    entradas.forEach(en => {
      if (!en.isIntersecting) return;
      const hermanos = [...en.target.parentElement.children].filter(n => n.classList.contains('reveal'));
      en.target.style.transitionDelay = Math.min(hermanos.indexOf(en.target), 4) * 80 + 'ms';
      en.target.classList.add('is-in');
      obs.unobserve(en.target);
    });
  }, { threshold:0.2, rootMargin:'0px 0px -8% 0px' });
  nodos.forEach(n => io.observe(n));
}

/* ============================================================
   BARRA FIJA DE COMPRA (celular) — aparece cuando el botón de compra
   sale de pantalla hacia arriba; toca "Agregar al carrito" del producto.
   ============================================================ */
function iniciarBarra(raiz){
  const barra = $('[data-uf-barra]', raiz);
  const acciones = $('.acciones', raiz), galeria = $('.galeria', raiz);
  if (!barra || !acciones || !('IntersectionObserver' in window)) return;
  const copiar = () => {
    $('[data-uf-barra-precio]', barra).textContent = $('[data-uf-precio]', raiz).textContent;
    const det = [...$$('.campo__top .valor', raiz)].map(v => v.textContent.trim()).filter(Boolean).join(' · ');
    $('[data-uf-barra-det]', barra).textContent = det;
    const carrito = $('[data-uf-carrito]', raiz), btn = $('[data-uf-barra-btn]', barra);
    btn.disabled = carrito.disabled;
    btn.textContent = carrito.disabled ? 'Agotado' : 'Agregar al carrito';
  };
  let debajo = false, pasoGaleria = false;
  const mostrar = () => {
    const ver = !debajo && pasoGaleria;
    barra.classList.toggle('is-visible', ver);
    barra.setAttribute('aria-hidden', String(!ver));
    $('[data-uf-barra-btn]', barra).tabIndex = ver ? 0 : -1;
    if (ver) copiar();
  };
  /* visible solo si el botón quedó ARRIBA (ya se pasó) o todavía no se llegó y se bajó de la galería */
  new IntersectionObserver(([e]) => { debajo = e.isIntersecting; mostrar(); }).observe(acciones);
  new IntersectionObserver(([e]) => { pasoGaleria = !e.isIntersecting && e.boundingClientRect.top < 0; mostrar(); }).observe(galeria);
  raiz.addEventListener('click', () => setTimeout(copiar, 0));
  $('[data-uf-barra-btn]', barra).addEventListener('click', () => $('[data-uf-carrito]', raiz).click());
}

/* Filtro Todo / Packs / Sueltas de las colecciones */
$$('[data-uf-filtro]').forEach(seg => seg.addEventListener('click', e => {
  const b = e.target.closest('button[data-filtro]'); if (!b) return;
  const f = b.dataset.filtro;
  $$('button', seg).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
  $$('[data-grupo]').forEach(g => g.hidden = f !== 'todo' && g.dataset.grupo !== f);
}));

/* "Guía de talla" y "Cómo elegir tu talla": abre la guía y baja hasta la tabla,
   descontando el header fijo de Impulse (el salto nativo del #ancla quedaba tapado). */
function irAGuia(e){
  const a = e.target.closest('a[href$="#uf-guia"]'); if (!a) return;
  const guia = $('#uf-guia'); if (!guia) return;          // en otra página: que navegue normal
  e.preventDefault();
  const det = $('details', guia); if (det) det.open = true;
  const destino = $('.tabla-talla', guia) || guia;
  const header = $('.site-header');
  const alto = header ? header.getBoundingClientRect().height : 0;   // al bajar queda fijo arriba
  const y = destino.getBoundingClientRect().top + scrollY - alto - 24;
  scrollTo({ top: Math.max(0, y), behavior: MOVIMIENTO ? 'smooth' : 'auto' });
  destino.classList.remove('is-foco'); void destino.offsetWidth; destino.classList.add('is-foco');
}
document.addEventListener('click', irAGuia);

$$('[data-uf-grid-sueltas]').forEach(pintarSueltas);
$$('[data-uf-pack-config]').forEach(iniciarPack);
$$('[data-uf-suelta]').forEach(iniciarSuelta);
$$('[data-uf-barra]').forEach(b => iniciarBarra(b.closest('.pdp')));
reveal();
})();
